import React from 'react';

import {
    FormControlClearButton,
    type FormControlClearButtonProps
} from '../../../FormControlClearButton/FormControlClearButton';
import { useSelectRootContext } from '../root/SelectRootContext';
import { useSelectTriggerContext } from '../trigger/SelectTrigger';

type SelectClearButtonProps = FormControlClearButtonProps;

export const SelectClearButton = ({ onClick, ...rest }: SelectClearButtonProps) => {
    const { selection, setOpen, setValue, setInternalSearchValue } = useSelectRootContext();
    const { onClear } = useSelectTriggerContext();
    const { mergedOnChange } = selection;

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        onClick?.(event as never);
        onClear?.();
        setValue('');
        mergedOnChange?.(undefined);
        setInternalSearchValue('');
        setOpen(false);
    };

    const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
        // Prevent the dropdown to open when clearing the field
        event.stopPropagation();
    };

    return <FormControlClearButton {...rest} onClick={handleClick} onMouseDown={handleMouseDown} />;
};
